import CancelSharpIcon from "@mui/icons-material/CancelSharp";
import CheckSharpIcon from "@mui/icons-material/CheckSharp";
import DoneAllSharpIcon from "@mui/icons-material/DoneAllSharp";
import PendingSharpIcon from "@mui/icons-material/PendingSharp";
import type { CSSProperties, FC } from "react";
import { INK, STATUS } from "../../../theme/tokens";
import type { MessageStatus } from "../../../utils/models";

type Props = {
	status: MessageStatus;
};

const iconStyles: CSSProperties = {
	fontSize: "14px",
};

export const CommunicationStatusToIcon: FC<Props> = ({ status }) => {
	switch (status) {
		case "accepted":
		case "queued":
		case "sending":
			return <PendingSharpIcon style={iconStyles} />;
		case "sent":
			return <CheckSharpIcon style={{ ...iconStyles, color: INK.SECONDARY }} />;
		case "delivered":
			return <DoneAllSharpIcon style={{ ...iconStyles, color: INK.SECONDARY }} />;
		case "failed":
		case "undelivered":
			return <CancelSharpIcon style={{ ...iconStyles, color: STATUS.ERROR.main }} />;
		case "received":
		case "receiving":
			return <></>;
		default:
			return (
				<span role="img" aria-label="unknown">
					❓
				</span>
			);
	}
};
